export default "__VITE_ASSET__CvvxT0Io__"